export const TierCardBackgrounds = () => {
  return (
    <div
      className="absolute inset-x-8 inset-y-0 grid grid-cols-4 gap-x-8 before:block"
      aria-hidden="true"
    >
      <div className="h-full w-full rounded-lg bg-halfmast-1100/80 shadow-xs" />
      <div className="h-full w-full rounded-lg bg-halfmast-1100/80 shadow-xs" />
      <div className="h-full w-full rounded-lg bg-halfmast-1100/80 shadow-xs" />
    </div>
  );
};
